import close_img from 'assets/close.svg';
import stars from 'assets/stars.gif';
import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
  min-width: 320px;
  max-width: 380px;
  padding: 24px;
  border: 1px solid #9e5eee;
  border-radius: 12px;
  background: rgba(29, 29, 29, 1);

  .modal-overlay.no-blur & {
    border: none;
  }

  @media (max-width: 599px) {
    border: none;
    border-top: 1px solid #9e5eee;
    max-width: 100vw;
    padding-bottom: 100px;
    margin: 16px;

    .modal-overlay.no-blur & {
      border-top: none;
    }
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  background-image: url(${close_img});
  top: 10px;
  right: 10px;

  width: 24px;
  height: 24px;

  border: none !important;
  cursor: pointer;

  &:before,
  &:after {
    border: none !important;
  }
`;

export const ModalWrapper = styled.div`
  max-width: 380px;

  @media (max-width: 599px) {
    max-width: 100%;
  }
`;

export const ModalContent = styled.div`
  box-sizing: border-box;
  height: auto;

  @media (max-width: 400px) {
    width: 100%;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const FeatureBlock = styled.div`
  margin-top: 32px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Feature = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
`;

export const FeatureImage = styled.img`
  width: 18px;
  height: 18px;
`;

export const PromotionBlock = styled.div`
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  position: relative;
  overflow: hidden;
  padding: 14px 24px;
  color: white;
  margin: 10px -25px 0 -25px;
  max-width: calc(100% + 50px);

  @media (max-width: 599px) {
    max-width: calc(100% + 48px);
  }
`;

export const PromotionStars = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${stars});
  background-size: cover;
  opacity: 0.1;
`;

export const PromotionContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const PromotionText = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 122px;
`;

export const PromotionLabel = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
`;

export const PromotionSubText = styled.div`
  font-size: 11px;
  font-weight: 700;
  line-height: 12px;
`;

export const PromotionTimer = styled.div`
  max-width: 154px;
  font-size: 20px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

const moveAnimation = keyframes`
  0% { left: -200%; }
  100% { left: 200%; }
`;

export const ModalButton = styled.button`
  width: 100%;
  height: 50px;
  padding: 8px 20px 8px 25px;
  border-radius: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #282828;
  box-shadow: none;
  margin-top: 12px;
`;

export const UpgradeButton = styled.button`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 50px;
  padding: 8px 20px 8px 25px;
  border-radius: 50px;
  margin-top: 12px;

  background: linear-gradient(
    90deg,
    rgb(158, 94, 238) 0%,
    rgb(183, 89, 234) 32%,
    rgb(198, 93, 233) 66%,
    rgb(184, 133, 244) 100%
  );

  box-shadow: none;
  overflow: hidden;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 10px;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    filter: blur(20px);
    animation: ${moveAnimation} 2s ease infinite;
  }
`;

export const TrialButton = styled.button`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 50px;
  padding: 8px 20px 8px 25px;
  border-radius: 50px;

  margin-top: 12px;

  border: 1px solid #282828;
  background: rgba(29, 29, 29, 1);

  overflow: hidden;
  color: white;
  cursor: pointer;
  font-size: 16px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 4px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  padding-top: 12px;
`;

export const InfoText = styled.div`
  color: rgba(169, 169, 169, 1);
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
`;

export const ButtonContainer = styled.div`
  padding: 0 13px 0 8px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const MainText = styled.p`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  @media (max-width: 399px){
    font-size: 14px;
  }
`;

export const SubText = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  column-gap: 29px;
`;

export const RightBox = styled.div`
  height: 24px;
  margin: auto 0;
  background-color: white;
  padding: 6px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
`;

export const RightText = styled.div`
  font-size: 11px;
  font-weight: 700;
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  line-height: 12px;
`;

export const PremiumIcon = styled.img`
  height: 48px;
  width: auto;
  margin-bottom: 8px;
`;

export const HeaderText = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 22px;
  color: white;
`;

export const GradientSpan = styled.span`
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 700;
`;

export const InfoToggle = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  justify-content: center;
  cursor: pointer;
`;

export const ChevronImage = styled.img<{ $isOpen: boolean }>`
  transform: ${props => (props.$isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;

export const InfoIcon = styled.img`
  width: 20px;
  height: 20px;
`;
